import { Download } from '@mui/icons-material';
import { Box, Button, Container, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import DetailGrid from '../components/DetailGrid';
import MainProjects from '../components/MainProjects';
import { useTheme } from '../contexts/ThemeContext';
import productsData from '../data/products.json';



const DetailedProduct = () => {
  const { t } = useTranslation();
  const { mode } = useTheme();
  const [searchParams] = useSearchParams();
  const [product, setProduct] = useState(null);
  const [modules, setModules] = useState(null);

  const handleDownloadCatalog = () => {
    console.log(modules, "modules in DetailedProduct")
    const link = document.createElement('a');
    link.href = modules.href;
    link.download = modules.download;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const productId = searchParams.get('product') || '1';
  useEffect(() => {
    const selectedProduct = productsData.products.find(p => p.id === parseInt(productId));
    if (selectedProduct) {
      setProduct({
        ...selectedProduct,
        name: t(`products.product${selectedProduct.id}.name`) || selectedProduct.name,
      });
    }

    async function loadModules() {
      try {
        // Dynamic import based on productId, use webpack's require.context or import()
        const file = await import(`../data/product${productId}-modules.json`);
        setModules(file.default || file);
      } catch (err) {
        setModules(null); // fallback or error state
      }
    }
    loadModules();
  }, [productId, t]);

  if (!product) {
    return <MainProjects />;
  }

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: (theme) =>
          mode === 'dark'
            ? 'radial-gradient(ellipse at top, #1e293b 0%, #0f172a 100%)'
            : 'radial-gradient(ellipse at top, #f8fafc 0%, #e2e8f0 100%)',
        position: 'relative',
        overflow: 'hidden',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background:
            'radial-gradient(circle at 20% 50%, rgba(99, 102, 241, 0.1) 0%, transparent 50%), ' +
            'radial-gradient(circle at 80% 80%, rgba(139, 92, 246, 0.1) 0%, transparent 50%)',
          pointerEvents: 'none',
        },
      }}
    >
      <Container maxWidth="xl">
        {/* Product Heading */}
        <Box
          sx={{
            py: { xs: 6, md: 8 },
            textAlign: 'center',
            position: 'relative',
            zIndex: 1,
          }}
        >
          <Typography
            variant="h1"
            sx={{
              fontSize: { xs: '2.5rem', md: '3.5rem', lg: '4rem' },
              fontWeight: 900,
              mb: 3,
              background: (theme) =>
                mode === 'dark'
                  ? 'linear-gradient(135deg, #fff 0%, #94a3b8 100%)'
                  : 'linear-gradient(135deg, #0f172a 0%, #334155 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
              lineHeight: 1.2,
              letterSpacing: '-0.02em',
            }}
          >
            {product.name}
          </Typography>
          {/* Header with Catalogue Button */}
          <Box sx={{ textAlign: 'center', mb: 6 }}>
            <Button
              variant="contained"
              startIcon={<Download />}
              onClick={handleDownloadCatalog}
              sx={{
                py: 1.5,
                px: 4,
                fontSize: '1rem',
                fontWeight: 600,
                textTransform: 'none',
                borderRadius: 2,
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                boxShadow: '0 8px 20px rgba(102, 126, 234, 0.4)',
                '&:hover': {
                  boxShadow: '0 12px 32px rgba(102, 126, 234, 0.6)',
                  transform: 'translateY(-2px)',
                },
                transition: 'all 0.3s ease',
              }}
            >
              {t('products.catalogue')}
            </Button>
          </Box>
        </Box>
        <MainProjects productId={productId} />
        {/* Only render DetailGrid if modules are loaded for this product */}
        <DetailGrid productId={productId} />

      </Container>
    </Box>
  );
};

export default DetailedProduct;